import { Modal } from '../../../../components/Modal';
import styles from './styles.module.scss';
import { SwiperSlider } from '../../../../components/SwiperSlider';
import MetroEntranceScene from './animations/MetroEntranceScene';
import { PeopleCountingScene } from './animations/PeopleCountingScene';

type TRulesModalProps = {
  onClose: () => void;
};

const slides = [
  {
    id: 1,
    text: 'Наблюдай за людьми, которые входят и выходят из метро.',
    scene: MetroEntranceScene,
  },
  {
    id: 2,
    text: 'Дай правильный ответ: сколько человек осталось в метро?',
    scene: PeopleCountingScene,
  },
];

const RulesModal: React.FC<TRulesModalProps> = ({ onClose }) => {
  return (
    <Modal onClose={onClose} variant="metro" closeOnOverlayClick={false}>
      <SwiperSlider variant="metro" spaceBetween={0} slidesPerView={1}>
        {slides.map((slide) => {
          const Scene = slide.scene;
          return (
            <div key={slide.id} className={styles.slide}>
              <Scene />
              <div className={styles.text}>{slide.text}</div>
            </div>
          );
        })}
      </SwiperSlider>
    </Modal>
  );
};

export default RulesModal;
